import styled from 'styled-components'

export const Mono = styled.span`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-feature-settings: 'tnum' 1;
`

export default Mono
